import moment from 'moment';

export const countPoint = (views: number, like: number) => {
	const point = (views / 2 + like) / 4;
	return Math.round(point);
};

export const formatPrice = (number: number) => {
	return new Intl.NumberFormat('id-ID', {
		style: 'currency',
		currency: 'IDR'
	}).format(number);
};

export const formatTimestamp = (timestamp: string) => {
	return moment(timestamp).format('D MMM YYYY hh:mm');
};

export const isEmptyObject = (obj: object): boolean => {
	return Object.keys(obj).length === 0;
};

export const countWord = (text: string | null): number => {
	return !text ? 0 : text.split(/\s+/).length;
};

export const capitalizeFirstLetter = (value: string) => {
	const word = value.toLowerCase();
	if (word.length === 0) {
		return word;
	}

	return word[0].toUpperCase() + word.slice(1);
};

export const stringToWord = (string: string) => {
	const words = string.split('_');
	const newWords = words.map((word) => capitalizeFirstLetter(word));

	return newWords.join(' ');
};

export function shortenNumber(num: number) {
	if (num >= 1_000_000_000) {
		return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
	} else if (num >= 1_000_000) {
		return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
	} else if (num >= 1_000) {
		return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
	} else {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	}
}